// extracted by mini-css-extract-plugin
export default {"login-page":"LoginPage_login-page__zhDoX"};